export default class Utils {

    static removeFile(filename, filetype){
        const el = (filetype==="js") ? "script" : (filetype ==="css") ? "link" : "none";
        const att = (filetype==="js") ? "src" : (filetype ==="css") ? "href" : "none";
        let els = document.getElementsByTagName(el);
        for (let i = els.length; i >= 0; i--){
            if (els[i] && els[i].getAttribute(att)!=null && els[i].getAttribute(att).indexOf(filename)!==-1)
                els[i].parentNode.removeChild(els[i])
        }
    }
}


